import { render, staticRenderFns } from "./ApprovalStateItem.vue?vue&type=template&id=d77d7e1a&"
import script from "./ApprovalStateItem.vue?vue&type=script&lang=js&"
export * from "./ApprovalStateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports